import { DestroyRef, Directive, EventEmitter, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgModel } from '@angular/forms';
import { debounceTime, distinctUntilChanged, skip } from 'rxjs/operators';
import { FIRST, ONE_SECOND } from './debounce-time.constant';

@Directive({
  selector: '[ngModelDebounceChange]',
  standalone: true,
})
export class NgModelDebounceChangeDirective implements OnInit {
  @Output() ngModelDebounceChange = new EventEmitter<string>();

  constructor(
    private _ngModel: NgModel,
    private _destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this._ngModel.control.valueChanges
      .pipe(takeUntilDestroyed(this._destroyRef), skip(FIRST), debounceTime(ONE_SECOND), distinctUntilChanged())
      .subscribe(value => this.ngModelDebounceChange.emit(value));
  }
}
